import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Legacy from "@/pages/Legacy";
import Future from "@/pages/Future";
import Leadership from "@/pages/Leadership";
import Ministries from "@/pages/Ministries";
import Events from "@/pages/Events";
import Media from "@/pages/Media";
import Give from "@/pages/Give";
import Visit from "@/pages/Visit";
import Contact from "@/pages/Contact";
import Gallery from "@/pages/Gallery";
import ThankYou from "@/pages/ThankYou";
import FamilyDay from "@/pages/FamilyDay";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

function PublicShell({ children }) {
  return <Layout>{children}</Layout>;
}

// Fires GA4 (and Google Ads) page_view on every route change so the SPA tracks
// each virtual navigation, not just the initial hard load.
function RouteAnalytics() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    try {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    } catch (_) {
      /* silent */
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RouteAnalytics />
          <Routes>
            {/* Public site */}
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/about" element={<PublicShell><About /></PublicShell>} />
            <Route path="/legacy" element={<PublicShell><Legacy /></PublicShell>} />
            <Route path="/future" element={<PublicShell><Future /></PublicShell>} />
            <Route path="/leadership" element={<PublicShell><Leadership /></PublicShell>} />
            <Route path="/ministries" element={<PublicShell><Ministries /></PublicShell>} />
            <Route path="/events" element={<PublicShell><Events /></PublicShell>} />
            <Route path="/media" element={<PublicShell><Media /></PublicShell>} />
            <Route path="/give" element={<PublicShell><Give /></PublicShell>} />
            <Route path="/visit" element={<PublicShell><Visit /></PublicShell>} />
            <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
            <Route path="/gallery" element={<PublicShell><Gallery /></PublicShell>} />
            <Route path="/family-day" element={<PublicShell><FamilyDay /></PublicShell>} />
            <Route path="/thank-you" element={<PublicShell><ThankYou /></PublicShell>} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/*" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />

            {/* Fallback */}
            <Route path="*" element={<PublicShell><Home /></PublicShell>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
